'use client'
import React, { useRef, useState } from 'react';
import LayoutCard from '@components/LayoutCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const NewDevelopmentPropertySlider = ({ properties, cardType="none", moreUrl='', dictionary, lang }) => {
    return (
    <div className='w-full'>
        <div className='flex flex-col my-4 sm:px-2 md:pl-0'>
            <div className='sm:block hidden'>
                <Swiper
                    // slidesPerView={'auto'}
                    spaceBetween={10}
                    slidesPerView={3}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    className=''
                >
                    {properties.map((property, index) => (
                        <SwiperSlide key={index}>
                            <LayoutCard property={property} dictionary={dictionary.card} lang={lang} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {properties && (
                <div className='sm:hidden block'>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1.5}
                    >
                        {properties.map((property, index) => (
                            <SwiperSlide key={index}>
                                {/* <PropertyCard property={property} cardType={cardType} dictionary={dictionary.card} lang={lang} /> */}
                                <LayoutCard property={property} cardType={cardType} dictionary={dictionary.card} lang={lang} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </div>
    </div>
  )
}

export default NewDevelopmentPropertySlider